<template>
    <div class="ctn">
        <div class="name">{{ name }}</div>
        <div v-show="loading" class="el-icon-loading val" />
        <slot v-show="!loading"></slot>

        <el-popover v-if="details && !loading" placement="top-start" width="800" trigger="hover">
            <json-view :data="details" theme="vs-code" icon-style="triangle" />
            <div slot="reference" class="el-icon-warning-outline details" />
        </el-popover>
    </div>
</template>

<script>
import jsonView from 'vue-json-views'

export default {
    name: "aboutItem",
    props: {
        name: String,
        loading: Boolean,
        details: Object,
    },
    components: {
        jsonView,
    },
}
</script>

<style scoped>
.ctn {
    padding: 0.2em 0;
    display: flex;
    align-items: baseline;
}
.name {
    padding-right: 0.5em;
}
.details {
    padding-left: 0.5em;
}
</style>